<template>
  <template v-if="loading === '1'">
    <nocaptcha v-if="useType == 'traceless'" ref="tracelesscaptcha" @captchaCheckBack="captchaCheckBack"
      @resetInit="init"></nocaptcha>
    <zy-popup ref="zyPopupRef" v-else-if="['slider', 'jigsaw', 'grid', 'ali'].includes(useType)"
      :title="tlang('verifiTitle') || '请完成安全验证'" :imgLoading="imgLoading" :left="popupLeft" :top="popupTop" :scene="scene" :useType="useType"
      :sceneID="sceneIDRef" :shake="zyShake" @refresh="refresh" @close="close">
      <slcaptcha v-if="useType === 'slider'" :scene="scene" @captchaCheckBack="captchaCheckBack" :reload="reload"
        :customLang="customLang" @resetInit="init"></slcaptcha>
      <jigsawcha v-else-if="useType === 'jigsaw'" ref="captchaRef" :imgLoading="imgLoading" :scene="scene" @captchaCheckBack="captchaCheckBack"
        :reload="reload" @zyShakeShow="zyShakeShow" :customLang="customLang" @resetInit="init"></jigsawcha>
      <gridcha v-else-if="useType === 'grid'" ref="captchaRef" :imgLoading="imgLoading" :scene="scene" @captchaCheckBack="captchaCheckBack"
        :reload="reload" @zyShakeShow="zyShakeShow" @close="gridchaClose" :customLang="customLang" @resetInit="init"></gridcha>
      <ali-new v-else-if="useType === 'ali'" ref="captchaRef" :positionId="positionId" :slideStyle="slideStyle" :checkAsk="checkAsk"
        @finish="finish" :scene="alisceneV2" :productKey="productKey" :customLang="customLang" :currentNode="currentNode"
        @resetInit="init"></ali-new>
    </zy-popup>
    <div class="init-err" v-else>{{ initeError }}</div>
  </template>
  <div class="xl-button__text" v-else-if="loading === '2'">
    <i class="xl-button__loading"></i>
  </div>
</template>

<script>
import AliNew from './ali-new.vue';
import Slcaptcha from './slider-zy.vue';
import ZyPopup from './zy-popup.vue';
import Nocaptcha from './traceless-zy.vue';
import Jigsawcha from './jigsawcha-zy.vue';
import Gridcha from './gridcha-zy.vue';
import { onMounted, onBeforeUnmount, computed, defineComponent, ref, nextTick } from 'vue';
import captchaApi from './api'
import { useUtils } from '../util/utils';
import { getVisitorId } from './initVisitorId';
import { UnHuffman, MD532Lower } from './encryption';
import { get, debounce } from 'lodash';
import { $rdoLang } from '../util/common';
import { encryptionData } from './encryption';
import { useMove } from './useMove';
import { isRobot } from './isRobot';
import { hideTextInImage } from './hideTextInImage';
import { useLang, useIndependentLang } from "../util/lang";
import { customBase64Encode, customBase64ByMap } from './custbase64';
import { VueCookieNext } from "vue-cookie-next";
import config from "../config.json";

export default defineComponent({
  emits: ['finish'],
  props: {
    scene: {
      type: String,
      default: 'register'
    },
    appID: {
      type: String
    },
    aliscene: {
      type: String,
      default: 'register'
    },
    productKey: String,
    currentNode:String,
    customLang: String,
    alisceneV2: { // 阿里验证码2.0的使用场景
      type: String,
      default: 'other'
    },
    webType: {
      type: String,
      default: 'web'
    },
    positionId: { // 阿里验证码2.0无感知二次验证弹框出来相对居中的元素，如无则屏幕居中
      type: String,
      default: ''
    },
    slideStyle: { // 验证码2.0滑块样式
      type: Object,
      default: {
        width: 340,
        height: 40
      }
    },
    initAsk: {
      type: Function
    },
    checkAsk: {
      type: Function
    },
    version: {
      type: String,
      default: 'v1' // v2阿里验证码2.0
    },
    loginType: String
  },
  setup(props, ctx) {
    let { $t: tlang } = useLang("@shining3d/xl-login");
    if ( props.customLang ) {
      tlang = useIndependentLang("@shining3d/xl-login", props.customLang).$t;
    }
    const zyShake = ref(false);
    const useType = ref();
    const encrypType = ref();
    const encrypKey = ref();
    const sceneIDRef = ref();

    const popupLeft = ref(-1);
    const popupTop = ref(-1);

    const loading = ref('');
    const imgLoading = ref(false);
    
    const initeError = ref('');

    let sessionObj = null;

    const Utils = useUtils();
    const rootUrl = Utils.getRootUrl(props.productKey);
    const pConfig = config[props.productKey];
    const usedLang = props.customLang || VueCookieNext.getCookie('lang');
    let verifyResult;
    let finishCallback;

    const getType = () => {
      return sessionStorage.getItem( 'ISQTSTYLE_TYPE' ) === '1';
    }

    function getInitOption(visitorId) {

      let platform = get(window, 'navigator.platform', '').toLocaleLowerCase();
      if (platform.includes('mac')) {
        platform = 'mac';
      } else if (platform.includes('win')) {
        platform = 'windows';
      } else if (platform.includes('linux')) {
        platform = 'linux';
      } else if (platform.includes('iphone') || platform.includes('ipad')) {
        platform = 'ios';
      } else {
        platform = 'android';
      }
      const language = $rdoLang(usedLang);
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return {
        productline: pConfig.productLine,
        grid: {
          width: 100,
          height: 100
        },
        jigsaw: {
          width: 300,
          height: 200
        },
        screen: {
          width: get(window, 'screen.width', 0),
          height: get(window, 'screen.height', 0),
          colorDepth: get(window, 'screen.colorDepth', 0),
        },
        browser: {
          language,
          fingerprint: visitorId,
          timeZone: userTimeZone
        },
        platform,
        language
      };
    }

    const getLeft = () => {
      if (!props.positionId) {
        return null;
      }
      const ele = document.getElementById(props.positionId);
      if (!ele) {
        return null;
      }
      const { left, top, width, height } = ele.getBoundingClientRect();
      const centerLeft = left + width / 2;
      const centerTop = top + height / 2;
      popupLeft.value = centerLeft;
      popupTop.value = centerTop;
    }

    const tracelessCallback = () => {
      if (zyPopupRef.value) {
        getLeftDeb();
        zyPopupRef.value.doShow();
        nextTick(() => {
          captchaRefInitData(sessionObj);
        })
      }
    }

    const captchaRefInitData = (sessionObj, isRefresh = true) => {
      if (captchaRef.value && isRefresh) {
        const imgs = get(sessionObj, 'data.imgs', []);
        const que = get(sessionObj, 'data.que', '');
        const cloud = get(sessionObj, 'data.cloud', '');
        captchaRef.value.initData({ ...sessionObj, imgs, que, cloud }, 2);
      }
    }
    const init = async (callback, isRefresh = false) => {
      imgLoading.value = true;
      const visitorId = await getVisitorId();
      encrypType.value = '';
      encrypKey.value = MD532Lower(visitorId + "|" + ( props.appID || get(window, 'app.global.appId', '')));
      let initData = getInitOption(visitorId);

      initData = encryptionData(JSON.stringify(initData), encrypKey.value, 0);
      initData = customBase64Encode(initData, 0);
      const params = {
        webType: props.webType,
        scene: props.alisceneV2,
        sourceFrom: pConfig.capSourceFrom,
        loginType: props.loginType || pConfig.loginType,
        data: initData
      };
      if (isRefresh && sessionObj && sessionObj.uniqueID) {
        // 刷新不重置loading.value
        if(!['ali', 'slider'].includes( useType.value )){
          // 阿里和滑动不传uniqueID
          params.uniqueID = sessionObj.uniqueID;
        }
      } else {
        loading.value = '2';
      }
      const initAsk = props.initAsk || captchaApi.authFusionInit;
      // , props.alisceneV2 === 'codelogin' ? '?channel=c&captchaType=grid' : ''
      initAsk(params, rootUrl, { headers: { 'X-Client-ID': visitorId } }, props.productKey).then((res) => {
        const status = get(res, 'status');
        const channel = get(res, 'result.channel');
        if (status === 'success' && channel) {
          const token = get(res, 'result.token', '');
          const uniqueID = get(res, 'result.uniqueID', '');
          const sceneID = get(res, 'result.sceneID', '');
          const region = get(res, 'result.region', '');
          const data = get(res, 'result.data', '');
          sceneIDRef.value = sceneID;
          sessionObj = {
            token,
            uniqueID,
            sceneID,
            region,
            data
          };
          encrypType.value = UnHuffman(channel.slice(1)).split('').map(Number);
          const utxt = channel.toString().startsWith('c') ? 'zy' : 'ali';
          // window.app.global.verifyCodeType = utxt;
          let useTypeTemp = 'ali';
          if (utxt === 'zy') {
            useTypeTemp = get(res, 'result.data.captchaType', '');
          }
          useType.value = useTypeTemp;
          loading.value = '1';
          nextTick(() => {
            if( callback === 'traceless' ){
              tracelessCallback()
              return;
            }
            captchaRefInitData(sessionObj, isRefresh);
            if (typeof callback === 'function') {
              callback(res);
            }
          })
        } else {
          if(res.result.includes('limitErr')){
            initeError.value = tlang('authFusionInitLimitErr') || '请求次数过多，请稍后再试';
          } else {
            initeError.value = tlang('verificationCodeInitErr') || '验证码初始化失败，请刷新页面重试';
          }
          loading.value = '1';
          useType.value = '';
          close();
        }
        imgLoading.value = false;
      }).catch(err => {
        console.log('authFusionInit请求出错了', err);
        if(err.toString().includes('limitErr')){
          initeError.value = tlang('authFusionInitLimitErr') || '请求次数过多，请稍后再试';
        } else {
          initeError.value = tlang('verificationCodeInitErr') || '验证码初始化失败，请刷新页面重试';
        }
        loading.value = '1';
        useType.value = '';
        close();
        imgLoading.value = false;
      })
    }

    // 初始化
    // init();

    const captchaRef = ref(null); //无痕验证ref
    const zyPopupRef = ref(null); //弹框ref

    const showCaptcha = computed(() => captchaRef.value.showCaptcha);

    const zyCloseFn = (flag = false) => {
      if (zyPopupRef.value) {
        zyPopupRef.value.close(flag);
      }
    }
    //验证结果回调
    function finish({ flag, result }) {
      hasTriggered.value = true;
      verifyState.value = true;
      const captcha = localStorage.getItem('slidingToken');
      const resns = Object.assign(result, { validType: useType.value, scene: props.scene, captcha });
      verifyResult = resns;
      if (finishCallback) {
        finishCallback(flag, resns);
        finishCallback = null;
        zyCloseFn();
        verifyResult = null;
        hasTriggered.value = false;
        verifyState.value = false;
      }
      ctx.emit('finish', result);
    }

    //触发重置
    function resetCaptcha() {
      // init(true);
      // captchaRef.value.resetCaptcha();
    }

    // 获取时间最晚的数组
    const getArrByTime = (arrA, arrB) => {
      const lena = arrA.length;
      const lenb = arrB.length;
      if (lena && lenb) {
        if (arrA[lena - 1].t > arrB[lenb - 1].t) {
          return arrA;
        } else {
          return arrB;
        }
      } else if (lena) {
        return arrA;
      } else if (lenb) {
        return arrB;
      } else {
        return [];
      }
    }

    const STP = '|';
    const arrToString = (arr) => {
      let str = '';
      for (let i = 0; i < arr.length; i++) {
        str += arr[i].x + STP + arr[i].y + STP + arr[i].t;
        if (i < arr.length - 1) {
          str += STP;
        }
      }
      return str;
    }

    const encryptedDatas = (jsonStr) => {
      const initOption = encryptionData(jsonStr, encrypKey.value, encrypType.value[1]);
      return customBase64Encode(initOption, encrypType.value[0]);
    }

    const captchaCheckBack = async ({ data, callback }) => {
      const ISQTSTYLE_TYPE = getType();
      let isBot = '';
      if(!ISQTSTYLE_TYPE){
        isBot = await isRobot();
        checkDev();
      }
      const visitorId = await getVisitorId();
      let captchaVerifyParam = '';
      const openIsDevToolsOpen = get(window, 'app.global.openIsDevToolsOpen');
      if(!openIsDevToolsOpen && !ISQTSTYLE_TYPE){
        captchaVerifyParam = sessionObj.uniqueID + (isBot.bot === false ? '0' : '1') + (isDevToolsOpen.value ? '1' : '0');
      } else {
        captchaVerifyParam = sessionObj.uniqueID + '00';
      }
      captchaVerifyParam = await hideTextInImage(captchaVerifyParam);
      captchaVerifyParam = customBase64ByMap(captchaVerifyParam, encrypType.value[0]);
      const traSting = arrToString(getArrByTime(mouseTrail.value, touchTrail.value));

      switch (useType.value) {
        case 'traceless':
          captchaVerifyParam = `${captchaVerifyParam}${traSting ? (STP + traSting) : ''}`;
          break;
        case 'slider':
        case 'jigsaw':
        case 'grid':
          captchaVerifyParam = `${captchaVerifyParam}${STP}${data}${STP}${traSting}`;
        default:
          break;
      }
      captchaVerifyParam = encryptedDatas(captchaVerifyParam);
      const dataP = {
        uniqueID: sessionObj.uniqueID,
        token: sessionObj.token,
        captchaVerifyParam,
      }
      const checkAsk = props.checkAsk || captchaApi.captchaFusionAuthCheck;
      checkAsk({ param: JSON.stringify(dataP) }, rootUrl, { headers: { 'X-Client-ID': visitorId } }, props.productKey).then((res) => {
        clear();
        let flag = true;
        const verifyResult = get(res, 'result.verifyResult', false);
        if (res.status === 'success' && verifyResult) {
          zyFinish({
            uniqueID: sessionObj.uniqueID,
            token: sessionObj.token
          })
        } else {
          flag = false
        }
        if (typeof callback === 'function') {
          callback(flag)
        }
      }).catch((err) => {
        if (typeof callback === 'function') {
          callback(false)
        }
        clear();
      })
    }

    const { mouseTrail, touchTrail, checkDev, isDevToolsOpen, clear } = useMove();
    const reload = ref(false); //是否重置验证码
    const hasTriggered = ref(false);//校验是否已触发
    const verifyState = ref(false); //captcha校验状态localStorage.getItem('slidingToken')
    const tracelesscaptcha = ref(null); //无痕验证ref
    localStorage.removeItem("slidingToken");
    //验证结果回调
    function zyFinish(res) {
      const captcha = localStorage.getItem('slidingToken');
      const ns = Object.assign(res, { validType: useType.value, scene: props.scene, captcha });
      verifyResult = ns;
      hasTriggered.value = true;
      verifyState.value = true;
      if (finishCallback) {
        finishCallback(true, ns);
        finishCallback = null;
        verifyResult = null;
        hasTriggered.value = false;
        verifyState.value = false;
      }
      zyCloseFn();
      ctx.emit('finish', ns);
    }
    const stateInitCallback = () => {
      if (useType.value !== 'ali') {
        if (useType.value == 'traceless') {
          return;
        }
        if (!hasTriggered.value) {
          getLeftDeb();
          if (zyPopupRef.value) {
            zyPopupRef.value.doShow();
          }
          nextTick(() => {
            switch (useType.value) {
              case 'jigsaw':
                if (captchaRef.value) {
                  const imgs = get(sessionObj, 'data.imgs', []);
                  const cloud = get(sessionObj, 'data.cloud', '');
                  captchaRef.value.initData({ imgs, cloud });
                }
                break;
              case 'grid':
                if (captchaRef.value) {
                  const imgs = get(sessionObj, 'data.imgs', []);
                  const que = get(sessionObj, 'data.que', '');
                  const cloud = get(sessionObj, 'data.cloud', '');
                  captchaRef.value.initData({ imgs, que, cloud });
                }
                break;
              default:
                break;
            }
          })
          return;
        }
      } else {
        getLeftDeb();
        if (zyPopupRef.value) {
          zyPopupRef.value.doShow();
        }
        nextTick(() => {
          if (captchaRef.value) {
            captchaRef.value.initData(sessionObj, 2);
          }
        })
      }
    };

    //调用阿里云验证码校验结果
    function aliyunCaptchaVerifyState(callback) {
      if(finishCallback){
        stateInitCallback();
      } else {
        finishCallback = callback;
        init(() => {
          stateInitCallback();
        });
      }
    }

    const refresh = () => {
      if (useType.value === 'ali') {
        captchaRef.value.refresh();
      } else {
        init(null, true);
      }
    }

    const zyShakeShow = () => {
      zyShake.value = true;
      setTimeout(() => {
        zyShake.value = false;
      }, 800)
    }

    const close = () => {
      if (finishCallback) {
        finishCallback(false, {});
        finishCallback = null;
      }
    }

    const gridchaClose = () => {
      close();
      zyCloseFn();
    }

    // 防抖
    const getLeftDeb = debounce(() => {
      getLeft();
    }, 100);

    onMounted(() => {
      getLeftDeb();
      window.addEventListener('resize', getLeftDeb)
    })

    onBeforeUnmount(() => {
      window.removeEventListener('resize', getLeftDeb)
    })

    return {
      imgLoading,
      initeError,
      gridchaClose,
      popupLeft,
      popupTop,
      close,
      zyShake,
      refresh,
      tlang,
      loading,
      showCaptcha,
      props,
      finish,
      sceneIDRef,
      captchaRef,
      zyPopupRef,
      useType,
      reload,
      zyShakeShow,
      init,
      aliyunCaptchaVerifyState,
      captchaCheckBack,
      resetCaptcha
    }
  },
  components: {
    AliNew,
    Slcaptcha,
    Nocaptcha,
    Jigsawcha,
    Gridcha,
    ZyPopup,
  }
})




</script>

<style scoped>
.captcha-wrap {
  width: 100%;
  position: relative;
}

.captcha-show {
  margin-top: 16px;
  height: 40px;
  margin-bottom: 5px !important;
}

.captcha-show[type='captcha-wrap-slider'] {
  height: auto;
  margin-bottom: 0px !important;
}

.smart-border {
  border: 1px solid #ccc;
  border-radius: 4px;
}

.captcha-wrap :deep(.alinc .nc_wrapper) {
  width: 100% !important;
  border-radius: 5px !important;
}

.captcha-wrap :deep(.alinc .sm-btn-default) {
  width: 100% !important;
  border-radius: 5px !important;
}

/* 智能验证码二次验证滑动验证码 */
.captcha-wrap :deep(.alinc .sm-pop) {
  width: 100% !important;
  border: none !important;
  height: 65px !important;
}


.captcha-wrap :deep(.alinc #rectMask) {
  width: 100% !important;
}

.captcha-wrap :deep(.alinc #SM_BTN_1) {
  width: calc(100% - 2px) !important;
  /* border: none !important; */
}

.xl-button__text {
  height: 36px;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 16px;
}
.init-err {
  color: var(--el-color-danger);
  font-size: 12px;
  line-height: 1;
  padding-top: 12px;
}
</style>